import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { ProjectService } from '../../services/project.service';

export interface SubMenuItem {
  label: string;
  icon: string;
  buttonStyleClass?: string;
  routerLink: string | [] | undefined;
}

@Component({
  selector: 'app-submenu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgClass, TabsModule],
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.scss']
})

export class SubmenuComponent {
  constructor(public route: ActivatedRoute, public projectService: ProjectService) { }
  public readonly items = input<SubMenuItem[]>([]);

  // Index des aktuell aktiven Tabs. Wird über routerLinkActive an jedem p-tab ermittelt,
  // damit die Tab-Auswahl (Ink-Bar) unabhängig davon funktioniert, ob routerLink relativ
  // oder absolut angegeben ist.
  public activeIndex: number = 0;

  public onActiveChange(index: number, isActive: boolean): void {
    if (isActive) {
      this.activeIndex = index;
    }
  }

}
